import { FC } from "react";
import { FieldInputProps } from "react-final-form";
import { useSelector } from "react-redux";

import { Warning } from "@livechat/design-system-icons";
import { IPickerListItem, Picker, Text } from "@livechat/design-system-react-components";

import { AgentDropdownItem } from "components/ds-multiselect";
import { IAgent, selectActiveAgents } from "store/entities/agents";
import { IRuleActionAddFollowers, IRuleActionRemoveFollowers } from "store/entities/rules/interfaces";

import { changeActionValues } from "../utils";

interface IProps {
  input: FieldInputProps<IRuleActionAddFollowers | IRuleActionRemoveFollowers>;
}

export const Followers: FC<IProps> = ({ input }) => {
  const availableFollowers = useSelector(selectActiveAgents);
  const options = availableFollowers.map(createAgentOption);
  const selected = input.value.followers.map(id => options.find(o => o.key === id) ?? createDeletedAgent(id));

  const onSelect = (selected: IPickerListItem[] | null): void => {
    changeActionValues(input, { followers: selected?.map(s => s.key) ?? [] });
  };

  return (
    <Picker
      options={options}
      onSelect={onSelect}
      placeholder="Select one follower or more…"
      type="multi"
      selected={selected}
      hideClearButton
      data-testid="followers-picker"
    />
  );
};

const createAgentOption = (agent: IAgent): IPickerListItem => ({
  key: agent.id,
  name: agent.name,
  customElement: {
    selectedItemBody: <Text>{agent.name}</Text>,
    listItemBody: (
      <AgentDropdownItem
        agentEmail={agent.email}
        agentName={agent.name}
        avatarUrl={agent.avatar ?? ""}
        agentId={agent.id}
      />
    ),
  },
});

const createDeletedAgent = (id: string): IPickerListItem => ({
  key: id,
  name: "Follower removed",
  icon: Warning,
  selectedTagOptions: {
    kind: "error",
  },
});
